import { AuthState, MutationClass } from '../../../models';

export class SetStateMutation implements MutationClass {

  public static execute(state: AuthState, newState: Partial<AuthState>): void {
    Object.assign(state, newState);
  }

}
